import React, { useContext, useState } from "react";
import {
  DataGrid,
  trTR,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import "./AccountingList.css";
import { trTR as coretrTR } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { StoreContext } from "shared/context/store-context";

const VehiclePaymentList = (props) => {
  const visibilityJSON = localStorage.getItem("vehiclepayment_visibility");
  const visibilityModel = visibilityJSON ? JSON.parse(visibilityJSON) : {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(visibilityModel);
  const filterJSON = localStorage.getItem("vehiclepayment_filter");
  const initialFilterModel = filterJSON ? JSON.parse(filterJSON) : { items: [] };
  const [filterModel, setFilterModel] = useState(initialFilterModel);

  const store = useContext(StoreContext);

  const theme = createTheme(
    {
      palette: {
        primary: { main: "#1976d2" },
      },
    },
    trTR,
    coretrTR,
    {
      GridCsvExportOptions: { fileName: "gh" },
    }
  );

  const filteredItems = props.items.filter((item) => item.startDate.toString() >= "2023-09");

  let columns = [
    {
      field: "school",
      headerName: "Okul",
      width: 300,
      valueGetter: (params) =>
        store.schoolOptions.find((item) => item.value.toString() === params.row.school.toString()).label,
    },
    {
      field: "vehicleRoute",
      headerName: "Rota",
      width: 400,
      valueGetter: (params) => {
        try {
          return store.vehicleRouteOptions.find((item) => item.value.toString() === params.row.vehicleRoute.toString())
            .label;
        } catch {
          return "";
        }
      },
    },

    { field: "owner", headerName: "Araç Sahibi", width: 300 },
    { field: "driver", headerName: "Sürücü", width: 300 },
    { field: "amount", headerName: "Ücret", width: 100 },
  ];

  const OnSelectionChangeHandler = (event) => {
    props.onItemSelect(event[0]);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{ utf8WithBom: true }} />
      </GridToolbarContainer>
    );
  }

  return (
    <div className="itemListContainer">
      <ThemeProvider theme={theme}>
        <DataGrid
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) => {
            localStorage.setItem("vehiclepayment_visibility", JSON.stringify(newModel));
            setColumnVisibilityModel(newModel);
          }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => {
            localStorage.setItem("vehiclepayment_filter", JSON.stringify(newModel));
            setFilterModel(newModel);
          }}
          key={filteredItems}
          density="compact"
          components={{
            Toolbar: CustomToolbar,
          }}
          rows={filteredItems}
          columns={columns}
          pageSize={100}
          getRowId={(r) => r.id}
          onSelectionModelChange={OnSelectionChangeHandler}
        />
      </ThemeProvider>
    </div>
  );
};

export default VehiclePaymentList;
